import {axiosInstance} from "@/plugins/axios";

export interface OriginDeterminationCertificatePayload {
    id_product_determinations: number[],
    id_user: number,
    id_customer: number,
    id_company: number,
    start_application_date: string,
    end_application_date: string,
}

export interface CertificateOfOriginPayload {
    id_item: number,
    start_application_date: string,
    end_application_date: string
}

export interface CertificateOfOriginURLPayload {
    uuid: string
}

export async function saveCertificateOfOrigin(payload: OriginDeterminationCertificatePayload) {
    const response = await axiosInstance
        .post('determination_certificates/create_or_update_many', payload);
    return response.data;
}

export async function getCertificatesOfOrigin(payload: CertificateOfOriginPayload ) {
    let url = 'determination_certificates?';
    
    if (payload.start_application_date && payload.end_application_date) {
        url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`;
    }

    if(payload.id_item) {
        url += `id_item=${payload.id_item}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}

export async function getCertificateToDownload(payload: CertificateOfOriginURLPayload) {
    let url = 'determination_certificates/url/';
    if (payload && payload.uuid) {
        url += `${payload.uuid}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}